/**
 * If enabled, trigger signup modal on user scroll on FD landing page
 * https:www.notion.so/faire/Landing-Page-Modal-Trigger-fff2efb5c25a80df9613fc0e576463e4
 */
export const FAIRE_DIRECT_SIGNUP_MODAL_TRIGGER_240822 = 'FAIRE_DIRECT_SIGNUP_MODAL_TRIGGER_240822';
